(() => {
	angular
		.module('main')
		.directive('addCalendarEventModal', addCalendarEventModal);

	addCalendarEventModal.$inject = [];

	function addCalendarEventModal() {
		return {
			restrict: 'E',
			scope: {
				isForClient: '<',
				addJob: '&',
				addLead: '&',
				addExtraShoot: '&',
				addAppointment: '&',
				disableButtons: '<',
				mainShootLabelName: '=',
				extraShootLabelName: '='
			},
			template: `
                        <div id="addNewModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header pt-pb-15">
                                       <btn-close></btn-close>
                                        <h3 class="modal-title">Add new</h3>
                                    </div>
                                    <div class="modal-body add-new-modal add-new-list" style="padding-bottom: 5px!important; padding-top: 30px!important">
                                        <h2 class="add-new-tip f-s-20">I want to add a new...</h2>
                                        
                                         <btn-add-new-job-element add="disableButtons || addLead({event:event})"
                                             icon="fi fi-leads fi-job mr-20"
                                             title="lead ({{mainShootLabelName | lowercase}})"
                                             description="Schedule a date and time for a new lead’s {{mainShootLabelName|lowercase}}."
                                        ></btn-add-new-job-element>
                                        
                                        <btn-add-new-job-element add="disableButtons || addJob({event:event})"
                                             icon="fi fi-jobs fi-job mr-20"
                                             title="job ({{mainShootLabelName | lowercase}})"
                                             description="Schedule a date and time for a new job’s {{mainShootLabelName|lowercase}}."
                                        ></btn-add-new-job-element>

                                        <btn-add-new-job-element add="disableButtons || addExtraShoot({event:event})"
                                             icon="fi fi-camera-cross fi-job mr-20"
                                             title="{{extraShootLabelName | lowercase}}"
                                             description="Schedule an {{extraShootLabelName|lowercase}} for an existing job."
                                             ng-if="!isForClient"
                                        ></btn-add-new-job-element>

                                        <btn-add-new-job-element add="disableButtons || addAppointment({event:event})"
                                             icon="fi fi-call fi-job mr-20"
                                             title="appointment"
                                             description="Schedule a date and time for an appointment."
                                             ng-if="!isForClient"
                                        ></btn-add-new-job-element>
                                      
                                    </div>
                                </div>
                            </div>
       
                        </div>
                 `,
			replace: true,
			transclude: true,
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/PageCalendar/addCalendarEventModal.js